import { apiRequest } from './api';

export const AnalyticsService = {
    /**
     * Track provider click event
     * @param {Object} data - Event data
     * @returns {Promise<Object>}
     */
    async trackProviderClick({
                                 tmdbId,
                                 kind,
                                 seasonNumber = null,
                                 providerName,
                                 providerType,
                                 surface,
                             }) {
        console.log('AnalyticsService.trackProviderClick', {
            tmdbId,
            kind,
            seasonNumber,
            providerName,
            providerType,
            surface
        });

        return apiRequest('/analytics/provider-click', {
            method: 'POST',
            body: {
                tmdbId,
                kind,
                seasonNumber,
                providerName,
                providerType,
                surface,
            },
        });
    },
};